import { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Modal, Tabs, Form, Input, DatePicker, Row, Col } from "antd"
import { X as CloseOutlined } from "lucide-react"
import { addVitals, getVitals } from "../../services/doctor/vitals/vitals"
import { useMessageApi } from "../../services/message api/MessageProvider"
import { useAuth } from "../../services/authentication_API/authService"
import moment from "moment/moment"
import dayjs from "dayjs"
import { use } from "react"
import { Country } from "country-state-city"

const { TabPane } = Tabs

export default function VitalsDisplay1({ appointment_id,patient_id,isVisible, onClose }) {  
  console.log("props vslue",appointment_id,patient_id,isVisible)
  const [form] = Form.useForm()
  const [modalWidth, setModalWidth] = useState(1300)
  const messageApi = useMessageApi();
  const {  userData } = useAuth();



  useEffect(() => {
    const updateWidth = () => {
      if (window.innerWidth < 576) {
        setModalWidth("100%") // full screen on mobile
      } else if (window.innerWidth < 768) {
        setModalWidth("95%")
      } else if (window.innerWidth < 992) {
        setModalWidth("85%")
      } else {
        setModalWidth(900)
      }
    }

    updateWidth()
    window.addEventListener("resize", updateWidth)
    return () => window.removeEventListener("resize", updateWidth)
  }, [])

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const formData = {
        ...values,
        hospital_id: userData?.parent_user_id,
        doctor_id: userData?.id,
        appointment_id: appointment_id,
        patient_id: patient_id,
        vital_date: values.vital_date
          ? dayjs(values.vital_date).format("YYYY-MM-DD")
          : null,
      };

      let result;
        result = await addVitals( formData);
      

      if (result?.success) {
            messageApi.success("Vitals added successfully!");       
            console.log("Form Data Submitted:", formData);
            onClose()
      } else {  
        
        messageApi.error(result.error || "Something went wrong");
      }
    } catch (error) {
      messageApi.error(error.message || "Submission failed");
      console.log("catch error:", error);
    }
  };

    useEffect(() => {
      const fetchData = async () => {
        if (appointment_id) {
          try {
            const result = await getVitals(appointment_id);
            console.log("Fetched Vitals Data:", result);
    
            if (result?.success) {
              const defaultValues = {
                ...result?.data,
                vital_date: result.vital_date
                  ? dayjs(result.vital_date, "YYYY-MM-DD")
                  : null,
              };
              form.setFieldsValue(defaultValues);
              }
            }
           catch (error) {
            console.error("Error fetching vitals:", error);
          }
        }
      };
    
      fetchData();
    }, []);
  



  return (
    <Modal
      title={
        <div
          className="bg-primary text-white p-3 m-0 d-flex justify-content-between align-items-center"
          style={{ backgroundColor: "#1890ff", margin: "-20px -24px 20px" }}
        >
          <span>Patient {patient_id}</span>
          <Button
            type="text"
            icon={<CloseOutlined className="text-white" />}
            onClick={onClose}
            style={{ color: "white" }}
          />
        </div>
      }
      open={isVisible}
      onCancel={onClose}
      maskClosable={false} 
        keyboard={false}
      footer={[
        <Button key="cancel" onClick={onClose} className="me-2">
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit} style={{ backgroundColor: "#1890ff" }}>
          Submit
        </Button>,
      ]}
      width={modalWidth}
      styles={{ padding: "0", maxHeight: "80vh", overflowY: "auto" }}
      style={{ top: 20 }}
      closable={false}
      centered
    >
      <Tabs defaultActiveKey="vitals" className="px-3">
        <TabPane tab="Vitals" key="vitals">
          <Form form={form} layout="vertical" className="p-3">
            <Form.Item label="Date" name="vital_date" values="vital_date">
              <DatePicker className="w-100" placeholder="Today, 28 Apr 2025" />
            </Form.Item>

            <Row gutter={[12, 6]}>
              <Col xs={24} sm={12} md={8}>
                <Form.Item label="Pulse (/min)" name="pulse" values="pulse">
                  <Input placeholder="Enter pulse rate" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item label="Systolic (mmHg)" name="systolic" values="systolic">
                  <Input placeholder="Enter systolic pressure" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item label="Diastolic (mmHg)" name="diastolic" values="diastolic">
                  <Input placeholder="Enter diastolic pressure" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item label="SPO2 (%)" name="spo2">
                  <Input placeholder="Enter SPO2 level" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item label="Temperature (°F)" name="temperature">
                  <Input placeholder="Enter temperature" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item label="Spot Blood Sugar (mg/dl)" name="spot_blood_sugar">
                  <Input placeholder="Enter blood sugar" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item label="Height (cm)" name="height">
                  <Input placeholder="Enter height" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item label="Weight (kg)" name="weight">
                  <Input placeholder="Enter weight" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item label="OFC (cm)" name="ofc">
                  <Input placeholder="Enter OFC" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item label="Waist (cm)" name="waist">
                  <Input placeholder="Enter waist" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item label="Hip (cm)" name="hip">
                  <Input placeholder="Enter hip" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Form.Item label="PEFR (L/min)" name="pefr">
                  <Input placeholder="Enter PEFR" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </TabPane>
        <TabPane tab="Investigations" key="investigations">
          <div className="p-4">
            <p>Investigations content goes here</p>
          </div>
        </TabPane>
      </Tabs>
    </Modal>
  )
}

VitalsDisplay1.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  appointment_id: PropTypes.any.isRequired,
  patient_id: PropTypes.any.isRequired,
}
